import { ActionCardModel } from '.'
import { MAX_SCORE_LIMIT, MIN_SCORE_LIMIT } from './constants'
import { scoreBasis } from './enums'
import { ActionCardData, SectionData } from './types'

export default function matchElementRange(
  element: {
    scoreBased?: scoreBasis
    minScore?: number
    maxScore?: number
    scoringDimensionId?: number
    idOfSep: number
  },
  state: ActionCardData,
) {
  if (!element.idOfSep) return true

  let matchRange = true

  const hasRange = typeof element.scoreBased === 'number'
  const minScore = typeof element.minScore === 'number' ? element.minScore : MIN_SCORE_LIMIT
  const maxScore = typeof element.maxScore === 'number' ? element.maxScore : MAX_SCORE_LIMIT

  if (element.scoreBased === scoreBasis.SEPARATOR && hasRange) {
    const separator = new ActionCardModel(state)
      .getSearchService()
      .find(node => (node.data as SectionData).id === element.idOfSep).data as SectionData

    matchRange = compare(separator?.score ?? 0)
  }

  if (element.scoreBased === scoreBasis.TOTAL && hasRange) {
    matchRange = compare(state.score)
  }

  if (element.scoreBased === scoreBasis.DIMENSION && hasRange) {
    const dimension = state.scoringDimensions?.find(dim => dim.id === element.scoringDimensionId)
    const dimensionScore = dimension?.actual || 0

    matchRange = compare(dimensionScore)
  }

  function compare(value: number) {
    return value >= minScore && value <= maxScore
  }

  return matchRange
}
